import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../configurations/configuration';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { State } from '../../models/state/state';
import { Country } from '../../models/country/country';
import { Language } from '../../models/language/language';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  private menus: string;
  private states: string;
  private countryUrl: string;
  private languageurl: string;
  constructor(private http: HttpClient) { 
    this.menus = environment.baseURI + environment.apiUrl + 'getMenus?role_id=' ;
    this.states = environment.baseURI + environment.apiUrl + 'getAllStates';
    this.countryUrl = environment.baseURI + environment.apiUrl + 'getAllCountries';
    this.languageurl = environment.baseURI + environment.apiUrl + 'getAllLanguages';
  }

  getMenus(role_id) {
    return this.http.get(this.menus + role_id, httpOptions);
  }


  getAllStates(): Observable<State> {
    return this.http.get<State>(this.states);
  }

  getAllCountries(): Observable<Country> {
    return this.http.get<Country>(this.countryUrl);
  }

  getAllLanguages(): Observable<Language> {
    return this.http.get<Language>(this.languageurl);
  }

}
